// extracted by css-extract-rspack-plugin
export default {"button":"RHXIM","adminButton":"Bi7po","hubButton":"A1jqA"};